import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Injectable({
  providedIn: 'root'
})

export class UrlcanonicaService {

  constructor(@Inject(DOCUMENT) private doc:any) {}

  createCanonicalLink() { 
    let links = this.doc.getElementsByTagName("link");
    links[1].setAttribute('href',this.doc.URL);
  }
}